exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "wage-advance-resume .wage-advance-resume{padding-top:31px}wage-advance-resume .wage-advance-resume.mobile .wage-advance-resume-row>div{width:100%;text-align:right}wage-advance-resume .wage-advance-resume.mobile .amount,wage-advance-resume .wage-advance-resume.mobile .reason{font-size:13px}wage-advance-resume .wage-advance-resume-row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:38px;margin-bottom:18px}wage-advance-resume .wage-advance-resume-label{color:#0072c9;display:inline-block;font-family:Stag Sans;font-size:13px;font-weight:400;line-height:1;text-transform:uppercase;width:195px}wage-advance-resume .wage-advance-resume-text{color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;line-height:1}wage-advance-resume .wage-advance-resume-buttons .btn-default{margin-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/wageAdvance/wageAdvanceResume/wageAdvanceResume.scss
// module id = 2140
// module chunks = 0